define(['angular','app'],function(angular,app) {
    app.filter('paginationStartFrom', function() {
        return function (input, start) {
            if(input)
                return input.slice(start);
        };
    });
});
